<script setup>
import {ref,watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
const emit = defineEmits(["modalHidden"])

const { t } = useI18n()
const props = defineProps(['visible'])

const showModal = ref(false)
const closeButton = ref(null)

const modalClose = () => {
  emit('modalHidden', true)
}

const cssClass = computed(() => {
  let value = 'd-none'
  if (showModal.value === true) {
    value = 'show'
    closeButton.value.focus()
  }
  return value
})

const styleCSS = computed(() => {
  let value = ''
  if (showModal.value === true) {
    value = 'display: block;'
  }
  return value
})

watch(() => props.visible, (newV) => {
  showModal.value = newV
})
</script>
<template>

  <div
      :class="` modal ${cssClass}`"
      :style="styleCSS"
  >
    <div
        class="modal-mask"
    >
    <div class="modal-results modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <slot name="modalHeader"></slot>
          </div>
          <button
              class="btn btn-primary publish assessment-survey-hide-during-print"
              @click="modalClose"
              ref="closeButton"
          >
            <span role="presentation" class="icon icon-remove"></span>
            <span class="sr-only">{{ $t('modal.close') }}</span>
          </button>

        </div>
        <div class="modal__content modal-body">
          <slot name="modalContent"></slot>
        </div>
        <div class="modal__footer modal-footer assessment-survey-hide-during-print">
          <slot name="modalFooter"></slot>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>